import { useSelector } from 'react-redux';
import Loader from 'src/common/Loader';
import LegacyVehicleDetails from 'src/components/vehicles/VehicleDetails';
import { isTyreManagementV2Enabled } from 'src/utils/tyreManagementFeature';
import VehicleDetailsV2 from './VehicleDetailsV2';

const VehicleDetailsRoute = () => {
  const { appSettings, appSettingsLoaded } = useSelector((state) => state.settings);

  if (!appSettingsLoaded) return <Loader />;

  const v2Enabled = isTyreManagementV2Enabled(appSettings)
    && appSettings?.vehicle_details_v2_enabled === true;

  return v2Enabled
    ? <VehicleDetailsV2 /> : <LegacyVehicleDetails />;
};

export default VehicleDetailsRoute;
